import AdyenTokenizeCardPaymentMethod from './AdyenTokenizeCardPaymentMethod';

export default class AdyenAuthNowCardPaymentMethod extends AdyenTokenizeCardPaymentMethod {
  constructor(option, form, paymentPage) {
    super(option, form, paymentPage);

    this.sessionId = $('meta[name=AdyenAuthorizeNowSessionId]').attr('content');
    this.sessionData = $('meta[name=AdyenAuthorizeNowSessionData]').attr('content');
    this.redirectPath = $('meta[name=AdyenAuthorizeNowRedirectPath]').attr('content');
  }

  onPaymentCompleted(result, component) {
    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ event: 'adyen_auth_now_card_payment_completed', data: { result: result.resultCode } }),
    });
    this.redirectTo(this.redirectPath);
  }

  redirectTo(path) {
    window.location.assign(path);
  }
}
